export { default } from './Product';
export { default as adapter } from './adapter';
